import http from "@/services/http";
import { defineStore } from "pinia";
import {ref} from 'vue';
import router from '@/router/index.js';
import { infos } from "./infos";

export const useAuth = defineStore('auth', () => {
    const useInfos = infos();
    const token = ref(localStorage.getItem('token'));
    const user = ref(localStorage.getItem('user'));
    const operator = ref(localStorage.getItem('operator'));
    const edit = ref(localStorage.getItem('edit'));
    // Permissões/loja do operador — o guard de rota chama checkAuth() em
    // toda navegação, então ficam sempre atualizadas com o que a API
    // devolve em /me (não só no momento do login).
    const canMakeSale = ref(localStorage.getItem('canMakeSale') === 'true');
    const canManageProduct = ref(localStorage.getItem('canManageProduct') === 'true');
    const canManageCustomer = ref(localStorage.getItem('canManageCustomer') === 'true');
    const canManageOnaccount = ref(localStorage.getItem('canManageOnaccount') === 'true');
    const canManageService = ref(localStorage.getItem('canManageService') === 'true');
    const canManageBudget = ref(localStorage.getItem('canManageBudget') === 'true');
    const servicesEnabled = ref(localStorage.getItem('servicesEnabled') === 'true');
    const storeId = ref(localStorage.getItem('storeId'));
    const storeName = ref(localStorage.getItem('storeName'));

    function setToken(tokenValue) {
        localStorage.setItem('token', tokenValue);
        token.value = tokenValue;
    }

    function setOperator(operatorValue) {
        localStorage.setItem('operator', operatorValue);
        operator.value = operatorValue;
    }

    function setUser(userValue) {
        localStorage.setItem('user', userValue);
        user.value = userValue;
    }

    function setEdit(editValue) {
        localStorage.setItem('edit', editValue);
        edit.value = editValue;
    }

    function setPermissions({ can_make_sale, can_manage_product, can_manage_customer, can_manage_onaccount, can_manage_service, can_manage_budget, services_enabled, store_id, store_name }) {
        canMakeSale.value = !!can_make_sale;
        canManageProduct.value = !!can_manage_product;
        canManageCustomer.value = !!can_manage_customer;
        canManageOnaccount.value = !!can_manage_onaccount;
        canManageService.value = !!can_manage_service;
        canManageBudget.value = !!can_manage_budget;
        servicesEnabled.value = !!services_enabled;
        storeId.value = store_id ?? null;
        storeName.value = store_name ?? '';
        localStorage.setItem('canMakeSale', canMakeSale.value);
        localStorage.setItem('canManageProduct', canManageProduct.value);
        localStorage.setItem('canManageCustomer', canManageCustomer.value);
        localStorage.setItem('canManageOnaccount', canManageOnaccount.value);
        localStorage.setItem('canManageService', canManageService.value);
        localStorage.setItem('canManageBudget', canManageBudget.value);
        localStorage.setItem('servicesEnabled', servicesEnabled.value);
        localStorage.setItem('storeId', storeId.value ?? '');
        localStorage.setItem('storeName', storeName.value ?? '');
    }

    function getBearer() {
        return {headers: { Authorization : "Bearer "+token.value }}
    }

    async function checkAuth(op) {
        try {
            const bearer = getBearer();
            const {data} = await http.get('/me', bearer);
            setPermissions(data);
            return true;
        } catch (error) {
            console.log(error?.response?.data);
            return false;
        }
    }

    async function TestCashierOpen(id) {
        try {
            const bearer = getBearer();
            const {data} = await http.post('/validate/cashie/'+id, {},bearer);
            const isValid = !!data?.user;
        } catch (error) {
            console.log(error?.response?.data);
            return false;
        }
    }

    function logout() {
        setToken('');
        setUser('');
        useInfos.setBusiness('');
        router.push({name: 'login'});
    }

    return {
        token, user, operator, setToken, setUser, checkAuth, getBearer, logout, setOperator, setEdit, edit, TestCashierOpen,
        canMakeSale, canManageProduct, canManageCustomer, canManageOnaccount, canManageService, canManageBudget, servicesEnabled, storeId, storeName, setPermissions,
    }
})
